/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export const DataAnnotationOrigin = {
    EXTERNAL: "EXTERNAL",
    MANUAL: "MANUAL",
    MODEL: "MODEL",
};
export const DataAnnotationStatus = {
    COMPLETE: "COMPLETE",
    PARTIAL: "PARTIAL",
    NONE: "NONE",
};
export const DataArrayDataType = {
    Bool: "Bool",
    I8: "I8",
    I16: "I16",
    I32: "I32",
    I64: "I64",
    U8: "U8",
    U16: "U16",
    U32: "U32",
    U64: "U64",
    F16: "F16",
    F32: "F32",
    F64: "F64",
};
export const DataBooleanOperator = {
    IS_TRUE: "IS_TRUE",
    IS_FALSE: "IS_FALSE",
};
export const DataCompatibilityStatus = {
    COMPATIBLE: "COMPATIBLE",
    INCOMPATIBLE: "INCOMPATIBLE",
};
export const DataCompressionInfo = {
    XLZ4: "application/x-lz4",
    ZSTD: "application/zstd",
    IDENTITY: "application/identity",
};
export const DataCopyPolicy = {
    REPLACE_EXISTING: "REPLACE_EXISTING",
    KEEP_EXISTING: "KEEP_EXISTING",
};
export const DataExamplePickingStrategy = {
    RANDOM: "RANDOM",
    LATEST: "LATEST",
};
export const DataImageFormat = {
    TIFF: "TIFF",
};
export const DataImageMode = {
    LU8: "L_U8",
    LF32: "L_F32",
    LF64: "L_F64",
    LAU8: "LA_U8",
    LAF32: "LA_F32",
    LAF64: "LA_F64",
    RGBU8: "RGB_U8",
    RGBF32: "RGB_F32",
    RGBF64: "RGB_F64",
    RGBAU8: "RGBA_U8",
    RGBAF32: "RGBA_F32",
    RGBAF64: "RGBA_F64",
    BGRU8: "BGR_U8",
    BGRF32: "BGR_F32",
    BGRF64: "BGR_F64",
    BGRAU8: "BGRA_U8",
    BGRAF32: "BGRA_F32",
    BGRAF64: "BGRA_F64",
    YCbCrU8: "YCbCr_U8",
    BayerRGU8: "BayerRG_U8",
    BayerRGU10: "BayerRG_U10",
    BayerRGU12: "BayerRG_U12",
    JPEG: "JPEG",
    PNG: "PNG",
    GIF: "GIF",
    BMP: "BMP",
};
export const DataNumberOperator = {
    IS_EQUAL_TO: "IS_EQUAL_TO",
    IS_NOT_EQUAL_TO: "IS_NOT_EQUAL_TO",
    IS_GREATER_THAN: "IS_GREATER_THAN",
    IS_GREATER_THAN_OR_EQUAL_TO: "IS_GREATER_THAN_OR_EQUAL_TO",
    IS_LESS_THAN: "IS_LESS_THAN",
    IS_LESS_THAN_OR_EQUAL_TO: "IS_LESS_THAN_OR_EQUAL_TO",
};
export const DataPixelDataLayout = {
    HeightWidthChannels: "HeightWidthChannels",
    ChannelsHeightWidth: "ChannelsHeightWidth",
};
export const DataSplitStrategy = {
    RANDOM: "RANDOM",
    STRATIFIED: "STRATIFIED",
};
export const DataTextOperator = {
    CONTAINS: "CONTAINS",
    DOES_NOT_CONTAIN: "DOES_NOT_CONTAIN",
    STARTS_WITH: "STARTS_WITH",
    IS_EXACTLY: "IS_EXACTLY",
    IS_EMPTY: "IS_EMPTY",
    IS_NOT_EMPTY: "IS_NOT_EMPTY",
};
export const DataTimestampOperator = {
    IS_ON: "IS_ON",
    IS_BEFORE: "IS_BEFORE",
    IS_AFTER: "IS_AFTER",
    IS_BETWEEN: "IS_BETWEEN",
};
export const DataTransformationMode = {
    JpegImages: "JpegImages",
};
import axios from "axios";
import qs from "qs";
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "/datastore/api/v1",
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "indices" }),
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;
        if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
            body = this.createFormData(body);
        }
        if (type === ContentType.UrlEncoded && body && body !== null && typeof body === "object") {
            body = qs.stringify(body);
        }
        if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
            body = JSON.stringify(body);
        }
        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        });
    };
}
/**
 * @title Robovision Datastore
 * @version 0.1.0
 * @baseUrl /datastore/api/v1
 */
export class Api extends HttpClient {
    embeddings = {
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples, embeddings
         * @name DeleteEmbeddings
         * @summary Delete the selected embeddings
         * @request POST:/embeddings/batch-delete
         * @secure
         */
        deleteEmbeddings: (data, params = {}) => this.request({
            path: `/embeddings/batch-delete`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples, embeddings
         * @name ListSampleEmbeddings
         * @summary List the embeddings for the specified sample
         * @request GET:/embeddings/{sample_id}
         * @secure
         */
        listSampleEmbeddings: (sampleId, params = {}) => this.request({
            path: `/embeddings/${sampleId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples, embeddings
         * @name DeleteEmbedding
         * @summary Delete the specified embedding
         * @request DELETE:/embeddings/{sample_id}/{node_id}/{embedding_name}
         * @secure
         */
        deleteEmbedding: (sampleId, nodeId, embeddingName, params = {}) => this.request({
            path: `/embeddings/${sampleId}/${nodeId}/${embeddingName}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples, embeddings
         * @name GetEmbedding
         * @summary Fetch the specified embedding
         * @request GET:/embeddings/{sample_id}/{node_id}/{embedding_name}
         * @secure
         */
        getEmbedding: (sampleId, nodeId, embeddingName, params = {}) => this.request({
            path: `/embeddings/${sampleId}/${nodeId}/${embeddingName}`,
            method: "GET",
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples, embeddings
         * @name AddEmbedding
         * @summary Fetch the specified embedding
         * @request POST:/embeddings/{sample_id}/{node_id}/{embedding_name}
         * @secure
         */
        addEmbedding: (sampleId, nodeId, embeddingName, data, params = {}) => this.request({
            path: `/embeddings/${sampleId}/${nodeId}/${embeddingName}`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            ...params,
        }),
    };
    livez = {
        /**
         * No description
         *
         * @name IsLive
         * @summary Liveness probe for the datastore
         * @request GET:/livez
         */
        isLive: (params = {}) => this.request({
            path: `/livez`,
            method: "GET",
            ...params,
        }),
    };
    nodeThumbnails = {
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name GetSampleNodeThumbnail
         * @summary Get the thumbnail for the specified data sample
         * @request GET:/node-thumbnails/{sample_id}/{node_id}/{profile}
         * @secure
         */
        getSampleNodeThumbnail: (sampleId, nodeId, profile, query, params = {}) => this.request({
            path: `/node-thumbnails/${sampleId}/${nodeId}/${profile}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
    };
    pools = {
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListPools
         * @summary List all datapools in the datastore
         * @request GET:/pools
         * @secure
         */
        listPools: (query, params = {}) => this.request({
            path: `/pools`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags datapools
         * @name CreatePool
         * @summary Create a new datapool
         * @request POST:/pools
         * @secure
         */
        createPool: (data, params = {}) => this.request({
            path: `/pools`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags datapools
         * @name DeletePool
         * @summary Delete the specified datapool and all containing data
         * @request DELETE:/pools/{pool_id}
         * @secure
         */
        deletePool: (poolId, params = {}) => this.request({
            path: `/pools/${poolId}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name GetAnnotation
         * @summary Get the specified annotation record
         * @request GET:/pools/{pool_id}/annotations/{sample_id}/{source_id}
         * @secure
         */
        getAnnotation: (poolId, sampleId, sourceId, query, params = {}) => this.request({
            path: `/pools/${poolId}/annotations/${sampleId}/${sourceId}`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListPoolClasses
         * @summary List the classes present in the specified datapool
         * @request GET:/pools/{pool_id}/classes
         * @secure
         */
        listPoolClasses: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/classes`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name CountPoolClasses
         * @summary Count the classes present in the specified datapool
         * @request GET:/pools/{pool_id}/classes/count
         * @secure
         */
        countPoolClasses: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/classes/count`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name CountCachedPoolClasses
         * @summary Get a (possibly outdated) cached count of classes present in the specified datapool
         * @request GET:/pools/{pool_id}/classes/count/cache
         * @secure
         */
        countCachedPoolClasses: (poolId, params = {}) => this.request({
            path: `/pools/${poolId}/classes/count/cache`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD PROJECT_CREATION * INFERENCE PROJECT_CREATION * LABELING_REVIEW PROJECT_CREATION
         *
         * @tags datapools
         * @name ClonePool
         * @summary Create a clone of the specified datapool
         * @request POST:/pools/{pool_id}/clone
         * @secure
         */
        clonePool: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/clone`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name CopyAnnotations
         * @summary Copy selected annotations from a given source to another source
         * @request POST:/pools/{pool_id}/copy-annotations
         * @secure
         */
        copyAnnotations: (poolId, data, query, params = {}) => this.request({
            path: `/pools/${poolId}/copy-annotations`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name GetPoolExampleDefinition
         * @summary Get the example definition of a pool
         * @request GET:/pools/{pool_id}/example-definition
         * @secure
         */
        getPoolExampleDefinition: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/example-definition`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags datapools
         * @name UpdatePoolExampleDefinition
         * @summary Update the example definition of a pool
         * @request PATCH:/pools/{pool_id}/example-definition
         * @secure
         */
        updatePoolExampleDefinition: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/example-definition`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools, tags
         * @name ListPoolExampleMetadataKeys
         * @summary List the example metadata keys present in the specified pool
         * @request POST:/pools/{pool_id}/example-metadata-keys
         * @secure
         */
        listPoolExampleMetadataKeys: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/example-metadata-keys`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * LABELING_REVIEW
         *
         * @tags datapools
         * @name AddExample
         * @summary Add a example to a given datapool
         * @request POST:/pools/{pool_id}/examples
         * @secure
         */
        addExample: (poolId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/examples`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name DeleteAnnotations
         * @summary Delete the specified examples
         * @request POST:/pools/{pool_id}/examples/batch-delete
         * @secure
         */
        deleteAnnotations: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/examples/batch-delete`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name InvalidateAnnotations
         * @summary Invalidate the specified examples without removing them
         * @request POST:/pools/{pool_id}/examples/batch-invalidate
         * @secure
         */
        invalidateAnnotations: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/examples/batch-invalidate`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name CountExamplesClasses
         * @summary Count the classes present in the specified example
         * @request POST:/pools/{pool_id}/examples/classes/count
         * @secure
         */
        countExamplesClasses: (poolId, data, query, params = {}) => this.request({
            path: `/pools/${poolId}/examples/classes/count`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name GetExample
         * @summary Get the specified example record
         * @request GET:/pools/{pool_id}/examples/{sample_id}/{source_id}
         * @secure
         */
        getExample: (poolId, sampleId, sourceId, query, params = {}) => this.request({
            path: `/pools/${poolId}/examples/${sampleId}/${sourceId}`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name GetExampleDescription
         * @summary Get the specified example record's description
         * @request GET:/pools/{pool_id}/examples/{sample_id}/{source_id}/description
         * @secure
         */
        getExampleDescription: (poolId, sampleId, sourceId, query, params = {}) => this.request({
            path: `/pools/${poolId}/examples/${sampleId}/${sourceId}/description`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datapools, tags
         * @name ListFilteredPoolTags
         * @summary List all tags in the specified datapool
         * @request POST:/pools/{pool_id}/filtered-tags
         * @secure
         */
        listFilteredPoolTags: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/filtered-tags`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name CheckPoolLabelCompatibility
         * @summary Check if the specified labels are compatible with the pool
         * @request POST:/pools/{pool_id}/label-compatibility
         * @secure
         */
        checkPoolLabelCompatibility: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/label-compatibility`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name GetPoolMetadata
         * @summary Get the metadata of a pool
         * @request GET:/pools/{pool_id}/metadata
         * @secure
         */
        getPoolMetadata: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/metadata`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags datapools
         * @name UpdatePoolMetadata
         * @summary Update the metadata of a pool
         * @request PUT:/pools/{pool_id}/metadata
         * @secure
         */
        updatePoolMetadata: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/metadata`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name GetCachedPoolMetadata
         * @summary Get a (possibly outdated) cached version of the metadata of a pool
         * @request GET:/pools/{pool_id}/metadata/cache
         * @secure
         */
        getCachedPoolMetadata: (poolId, params = {}) => this.request({
            path: `/pools/${poolId}/metadata/cache`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListPoolSampleMetadata
         * @summary List metadata of all samples that are present in the specified datapool
         * @request GET:/pools/{pool_id}/sample-metadata
         * @secure
         */
        listPoolSampleMetadata: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/sample-metadata`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListPoolSamples
         * @summary List all samples that are present in the specified datapool
         * @request GET:/pools/{pool_id}/samples
         * @secure
         */
        listPoolSamples: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/samples`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * LABELING_REVIEW
         *
         * @tags datapools
         * @name AddSample
         * @summary Add a sample to a given datapool
         * @request POST:/pools/{pool_id}/samples
         * @secure
         */
        addSample: (poolId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListPoolSamplesWithIntersection
         * @summary List all samples that are present in the specified datapool
         * @request POST:/pools/{pool_id}/samples-intersection
         * @secure
         */
        listPoolSamplesWithIntersection: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples-intersection`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name BulkUpdateAnnotations
         * @summary Patch the specified samples with new records in bulk
         * @request PATCH:/pools/{pool_id}/samples/annotations
         * @secure
         */
        bulkUpdateAnnotations: (poolId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/annotations`,
            method: "PATCH",
            query: query,
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name BulkOverwriteAnnotations
         * @summary Overwrite the annotations of the specified samples with new records in bulk
         * @request PUT:/pools/{pool_id}/samples/annotations
         * @secure
         */
        bulkOverwriteAnnotations: (poolId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/annotations`,
            method: "PUT",
            query: query,
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * LABELING_REVIEW
         *
         * @tags samples-examples
         * @name DeleteSamples
         * @summary Delete the specified samples
         * @request POST:/pools/{pool_id}/samples/batch-delete
         * @secure
         */
        deleteSamples: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/batch-delete`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * LABELING_REVIEW
         *
         * @tags samples-examples
         * @name InvalidateSamples
         * @summary Invalidate the specified samples without removing them
         * @request POST:/pools/{pool_id}/samples/batch-invalidate
         * @secure
         */
        invalidateSamples: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/batch-invalidate`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name ListSamplesClasses
         * @summary List the classes present for the filtered samples
         * @request POST:/pools/{pool_id}/samples/classes
         * @secure
         */
        listSamplesClasses: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/classes`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name CountSamplesClasses
         * @summary Count the classes present for the filtered samples
         * @request POST:/pools/{pool_id}/samples/classes/count
         * @secure
         */
        countSamplesClasses: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/classes/count`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name CountPoolSamples
         * @summary Count all samples that are present in the specified datapool matching the filters
         * @request GET:/pools/{pool_id}/samples/count
         * @secure
         */
        countPoolSamples: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/samples/count`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name CountPoolSamplesWithIntersection
         * @summary Count all samples that are present in the specified datapool matching the filters
         * @request POST:/pools/{pool_id}/samples/count-intersection
         * @secure
         */
        countPoolSamplesWithIntersection: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/count-intersection`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name UpdateFilteredAnnotations
         * @summary Update the annotations of the specified samples with new records in bulk
         * @request PATCH:/pools/{pool_id}/samples/filtered-annotations
         * @secure
         */
        updateFilteredAnnotations: (poolId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/filtered-annotations`,
            method: "PATCH",
            query: query,
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name OverwriteFilteredAnnotations
         * @summary Overwrite the annotations of the specified samples with new records in bulk
         * @request PUT:/pools/{pool_id}/samples/filtered-annotations
         * @secure
         */
        overwriteFilteredAnnotations: (poolId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/filtered-annotations`,
            method: "PUT",
            query: query,
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * LABELING_REVIEW
         *
         * @tags datapools
         * @name AddImageSample
         * @summary Add an image as sample to a given datapool
         * @request POST:/pools/{pool_id}/samples/image
         * @secure
         */
        addImageSample: (poolId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/image`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name GetSample
         * @summary Get the specified sample record
         * @request GET:/pools/{pool_id}/samples/{sample_id}
         * @secure
         */
        getSample: (poolId, sampleId, query, params = {}) => this.request({
            path: `/pools/${poolId}/samples/${sampleId}`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name UpdateAnnotations
         * @summary Patch a specified sample with a new record
         * @request PATCH:/pools/{pool_id}/samples/{sample_id}/annotations
         * @secure
         */
        updateAnnotations: (poolId, sampleId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/${sampleId}/annotations`,
            method: "PATCH",
            query: query,
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags samples-examples
         * @name OverwriteAnnotations
         * @summary Overwrite the annotations of a specified sample with a new record
         * @request PUT:/pools/{pool_id}/samples/{sample_id}/annotations
         * @secure
         */
        overwriteAnnotations: (poolId, sampleId, query, data, params = {}) => this.request({
            path: `/pools/${poolId}/samples/${sampleId}/annotations`,
            method: "PUT",
            query: query,
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name GetSampleDescription
         * @summary Get the specified sample record's description
         * @request GET:/pools/{pool_id}/samples/{sample_id}/description
         * @secure
         */
        getSampleDescription: (poolId, sampleId, query, params = {}) => this.request({
            path: `/pools/${poolId}/samples/${sampleId}/description`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name GetSampleImage
         * @summary Get the specified sample image
         * @request GET:/pools/{pool_id}/samples/{sample_id}/image
         * @secure
         */
        getSampleImage: (poolId, sampleId, query, params = {}) => this.request({
            path: `/pools/${poolId}/samples/${sampleId}/image`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datapools, tags
         * @name ListSampleTags
         * @summary List all tags that are assigned to the given sample
         * @request GET:/pools/{pool_id}/samples/{sample_id}/tags
         * @secure
         */
        listSampleTags: (poolId, sampleId, query, params = {}) => this.request({
            path: `/pools/${poolId}/samples/${sampleId}/tags`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datapools, datasets
         * @name ListPoolSets
         * @summary List all the datasets defined on the specified datapool
         * @request GET:/pools/{pool_id}/sets
         * @secure
         */
        listPoolSets: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/sets`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datapools, datasets
         * @name CreateSets
         * @summary Define a new dataset (split) on the specified datapool
         * @request POST:/pools/{pool_id}/sets
         * @secure
         */
        createSets: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/sets`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListPoolSources
         * @summary List the sources present in the specified datapool
         * @request GET:/pools/{pool_id}/sources
         * @secure
         */
        listPoolSources: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/sources`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListFilteredPoolSources
         * @summary List the sources present in the specified datapool for the filtered samples
         * @request POST:/pools/{pool_id}/sources
         * @secure
         */
        listFilteredPoolSources: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/sources`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datapools, tags
         * @name ListPoolTags
         * @summary List all tags in the specified datapool
         * @request GET:/pools/{pool_id}/tags
         * @secure
         */
        listPoolTags: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/tags`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datapools, tags
         * @name CreateTag
         * @summary Create new tags in the specified datapool
         * @request POST:/pools/{pool_id}/tags
         * @secure
         */
        createTag: (poolId, data, params = {}) => this.request({
            path: `/pools/${poolId}/tags`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name GetPoolThumbnail
         * @summary Get the thumbnail for the specified datapool
         * @request GET:/pools/{pool_id}/thumbnail
         * @secure
         */
        getPoolThumbnail: (poolId, query, params = {}) => this.request({
            path: `/pools/${poolId}/thumbnail`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
    };
    sets = {
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name ListSetsForSchema
         * @summary List all datasets that are compatible with the schema in the specified example definition
         * @request POST:/sets/list-for-schema
         * @secure
         */
        listSetsForSchema: (data, query, params = {}) => this.request({
            path: `/sets/list-for-schema`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datasets
         * @name DeleteSet
         * @summary Delete the specified dataset
         * @request DELETE:/sets/{set_id}
         * @secure
         */
        deleteSet: (setId, params = {}) => this.request({
            path: `/sets/${setId}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datasets
         * @name GetSetAnnotation
         * @summary Get the specified annotation record from the given dataset
         * @request GET:/sets/{set_id}/annotations/{sample_id}
         * @secure
         */
        getSetAnnotation: (setId, sampleId, params = {}) => this.request({
            path: `/sets/${setId}/annotations/${sampleId}`,
            method: "GET",
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name ListSetClasses
         * @summary List the classes present in the specified dataset
         * @request GET:/sets/{set_id}/classes
         * @secure
         */
        listSetClasses: (setId, query, params = {}) => this.request({
            path: `/sets/${setId}/classes`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name CountSetClasses
         * @summary Count the classes present in the specified dataset
         * @request GET:/sets/{set_id}/classes/count
         * @secure
         */
        countSetClasses: (setId, query, params = {}) => this.request({
            path: `/sets/${setId}/classes/count`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name CountCachedSetClasses
         * @summary Get a (possibly outdated) cached count of classes present in the specified dataset
         * @request GET:/sets/{set_id}/classes/count/cache
         * @secure
         */
        countCachedSetClasses: (setId, params = {}) => this.request({
            path: `/sets/${setId}/classes/count/cache`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name GetSetExampleDefinition
         * @summary Get the example definition of a set
         * @request GET:/sets/{set_id}/example-definition
         * @secure
         */
        getSetExampleDefinition: (setId, params = {}) => this.request({
            path: `/sets/${setId}/example-definition`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name ListSetExampleMetadataKeys
         * @summary List the example metadata keys present in the specified dataset
         * @request POST:/sets/{set_id}/example-metadata-keys
         * @secure
         */
        listSetExampleMetadataKeys: (setId, data, params = {}) => this.request({
            path: `/sets/${setId}/example-metadata-keys`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name ListSetExamples
         * @summary List the examples present in the specified dataset
         * @request GET:/sets/{set_id}/examples
         * @secure
         */
        listSetExamples: (setId, query, params = {}) => this.request({
            path: `/sets/${setId}/examples`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name ListSetExamplesWithIntersection
         * @summary List the examples present in the specified dataset
         * @request POST:/sets/{set_id}/examples-intersection
         * @secure
         */
        listSetExamplesWithIntersection: (setId, data, params = {}) => this.request({
            path: `/sets/${setId}/examples-intersection`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name CountSetExamplesClasses
         * @summary Count the classes present in the requested examples in a set
         * @request POST:/sets/{set_id}/examples/classes/count
         * @secure
         */
        countSetExamplesClasses: (setId, data, params = {}) => this.request({
            path: `/sets/${setId}/examples/classes/count`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name CountSetExamples
         * @summary Count the examples present in the specified dataset matching the filters
         * @request GET:/sets/{set_id}/examples/count
         * @secure
         */
        countSetExamples: (setId, query, params = {}) => this.request({
            path: `/sets/${setId}/examples/count`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name CountSetExamplesWithIntersection
         * @summary Count the examples present in the specified dataset matching the filters
         * @request POST:/sets/{set_id}/examples/count-intersection
         * @secure
         */
        countSetExamplesWithIntersection: (setId, data, params = {}) => this.request({
            path: `/sets/${setId}/examples/count-intersection`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datasets
         * @name GetSetExample
         * @summary Get the specified example record from the given dataset
         * @request GET:/sets/{set_id}/examples/{sample_id}
         * @secure
         */
        getSetExample: (setId, sampleId, query, params = {}) => this.request({
            path: `/sets/${setId}/examples/${sampleId}`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datasets
         * @name GetSetExampleDescription
         * @summary Get the specified example record's description
         * @request GET:/sets/{set_id}/examples/{sample_id}/description
         * @secure
         */
        getSetExampleDescription: (setId, sampleId, params = {}) => this.request({
            path: `/sets/${setId}/examples/${sampleId}/description`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name GetSetMetadata
         * @summary Get the metadata of a set
         * @request GET:/sets/{set_id}/metadata
         * @secure
         */
        getSetMetadata: (setId, params = {}) => this.request({
            path: `/sets/${setId}/metadata`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datasets
         * @name UpdateSetMetadata
         * @summary Update the metadata of a set
         * @request PUT:/sets/{set_id}/metadata
         * @secure
         */
        updateSetMetadata: (setId, data, params = {}) => this.request({
            path: `/sets/${setId}/metadata`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name GetCachedSetMetadata
         * @summary Get a (possible outdated) cached version of the metadata of a set
         * @request GET:/sets/{set_id}/metadata/cache
         * @secure
         */
        getCachedSetMetadata: (setId, params = {}) => this.request({
            path: `/sets/${setId}/metadata/cache`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datasets
         * @name GetSetSample
         * @summary Get the specified sample record from the given dataset
         * @request GET:/sets/{set_id}/samples/{sample_id}
         * @secure
         */
        getSetSample: (setId, sampleId, params = {}) => this.request({
            path: `/sets/${setId}/samples/${sampleId}`,
            method: "GET",
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datasets
         * @name GetSetSampleImage
         * @summary Get the specified sample image from the given dataset
         * @request GET:/sets/{set_id}/samples/{sample_id}/image
         * @secure
         */
        getSetSampleImage: (setId, sampleId, query, params = {}) => this.request({
            path: `/sets/${setId}/samples/${sampleId}/image`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets
         * @name ListSetSources
         * @summary List the sources present in the specified dataset
         * @request GET:/sets/{set_id}/sources
         * @secure
         */
        listSetSources: (setId, params = {}) => this.request({
            path: `/sets/${setId}/sources`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags datasets, tags
         * @name ListSetTags
         * @summary List all tags in the specified dataset
         * @request GET:/sets/{set_id}/tags
         * @secure
         */
        listSetTags: (setId, query, params = {}) => this.request({
            path: `/sets/${setId}/tags`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
    };
    tags = {
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name ListTags
         * @summary List all tags
         * @request GET:/tags
         * @secure
         */
        listTags: (query, params = {}) => this.request({
            path: `/tags`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name DeleteTag
         * @summary Delete the specified tag
         * @request DELETE:/tags/{tag_id}
         * @secure
         */
        deleteTag: (tagId, query, params = {}) => this.request({
            path: `/tags/${tagId}`,
            method: "DELETE",
            query: query,
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name GetTagMetadata
         * @summary Get the metadata of a tag
         * @request GET:/tags/{tag_id}/metadata
         * @secure
         */
        getTagMetadata: (tagId, query, params = {}) => this.request({
            path: `/tags/${tagId}/metadata`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name UpdateTagMetadata
         * @summary Update the metadata of a tag
         * @request PUT:/tags/{tag_id}/metadata
         * @secure
         */
        updateTagMetadata: (tagId, data, params = {}) => this.request({
            path: `/tags/${tagId}/metadata`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name GetCachedTagMetadata
         * @summary Get a (possible outdated) cached version of the metadata of a tag
         * @request GET:/tags/{tag_id}/metadata/cache
         * @secure
         */
        getCachedTagMetadata: (tagId, params = {}) => this.request({
            path: `/tags/${tagId}/metadata/cache`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name TagPoolSamples
         * @summary Tag samples with a given tag
         * @request POST:/tags/{tag_id}/samples/batch-pool-add
         * @secure
         */
        tagPoolSamples: (tagId, data, params = {}) => this.request({
            path: `/tags/${tagId}/samples/batch-pool-add`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name UntagPoolSamples
         * @summary Untag the samples from the given tag
         * @request POST:/tags/{tag_id}/samples/batch-pool-delete
         * @secure
         */
        untagPoolSamples: (tagId, data, params = {}) => this.request({
            path: `/tags/${tagId}/samples/batch-pool-delete`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD INFERENCE * INFERENCE LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name TagSetSamples
         * @summary Tag samples with a given tag
         * @request POST:/tags/{tag_id}/samples/batch-set-add
         * @secure
         */
        tagSetSamples: (tagId, data, params = {}) => this.request({
            path: `/tags/${tagId}/samples/batch-set-add`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD INFERENCE * INFERENCE LABELING_REVIEW * MODEL_CREATION
         *
         * @tags tags
         * @name UntagSetSamples
         * @summary Untag the samples from the given tag
         * @request POST:/tags/{tag_id}/samples/batch-set-delete
         * @secure
         */
        untagSetSamples: (tagId, data, params = {}) => this.request({
            path: `/tags/${tagId}/samples/batch-set-delete`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
    };
    thumbnails = {
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags samples-examples
         * @name GetThumbnail
         * @summary Get the thumbnail for the specified data sample
         * @request GET:/thumbnails/{sample_id}
         * @secure
         */
        getThumbnail: (sampleId, query, params = {}) => this.request({
            path: `/thumbnails/${sampleId}`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
    };
}
//# sourceMappingURL=data:application/json;base64,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